// extracted by mini-css-extract-plugin
export default {"meals_container":"mealsPerMealtype_meals_container__FidHA","meal_recipes":"mealsPerMealtype_meal_recipes__LnbJz"};